import React from "react";
import EventNameInput from "./EventNameInput";
import EventDescriptionInput from "./EventDescriptionInput";
import EventOrganiserSelector from "./EventOrganiserSelector";
import StaffAttendanceSelector from "./StaffAttendanceSelector";
import EventCategoriesSelector from "./EventCategoriesSelector";

const EventDetails = ({ data, onChange }) => {
  return (
    <div className="space-y-6">
      <EventNameInput eventName={data.eventName} onChange={onChange} />
      <EventDescriptionInput
        description={data.eventDescription}
        onChange={onChange}
      />
      <EventCategoriesSelector
        selectedCategory={data.category}
        onChange={onChange}
      />
      <EventOrganiserSelector data={data} onChange={onChange} />
      <StaffAttendanceSelector data={data} onChange={onChange} />

      {/* ✅ External providers checkbox */}
      <div className="flex flex-col justify-center gap-3 text-sm text-gray-700">
        <label className="block font-medium text-gray-700 mb-1">
          External providers
        </label>
        <div className="flex items-center gap-3">
          {" "}
          <input
            type="checkbox"
            id="externalProvidersUsed"
            checked={data.externalProvidersUsed || false}
            onChange={(e) =>
              onChange("externalProvidersUsed", e.target.checked)
            }
            className="h-4 w-4 text-blue-600 border-gray-300 rounded"
          />
          <label htmlFor="externalProvidersUsed">
            External providers will be used for this event
          </label>
        </div>
      </div>
    </div>
  );
};

export default EventDetails;
